export const regular = 'var(--seed-static-font-weight-regular)';
export const bold = 'var(--seed-static-font-weight-bold)';